import React, { useEffect, useMemo } from 'react';
import { Col } from 'react-bootstrap';
import { FreightValuesRegister } from 'v3/components/FreightValues';
import Tab from 'v3/components/FreightValues/components/Tabs';

export default function FreightValues({
  freightValuesRef,
  freightValuesReplaceRef,
  cargoValue,
  isReplacement,
  isNational,
}) {
  const [tabSelected, setTabSelected] = React.useState('tab1');

  useEffect(() => {
    if (!isReplacement) {
      setTabSelected('tab1');
    }
  }, [isReplacement]);

  const hasFreightValuesError = useMemo(() => {
    return Object.keys(freightValuesRef?.current?.errors || {}).length > 0;
  }, [freightValuesRef?.current?.errors]);

  const hasFreightValuesReplaceError = useMemo(() => {
    return Object.keys(freightValuesReplaceRef?.current?.errors || {}).length > 0;
  }, [freightValuesReplaceRef?.current?.errors]);

  return (
    <>
      {isReplacement && (
        <Col className="d-flex">
          <Tab
            active={tabSelected === 'tab1'}
            onClick={() => setTabSelected('tab1')}
            error={hasFreightValuesError}
          >
            1ª Troca Nota
          </Tab>
          <Tab
            active={tabSelected === 'tab2'}
            onClick={() => setTabSelected('tab2')}
            error={hasFreightValuesReplaceError}
          >
            2ª Troca Nota
          </Tab>
        </Col>
      )}
      <div
        className={tabSelected === 'tab1' ? 'd-block' : 'd-none'}
        style={{
          width: '100%',
        }}
      >
        <FreightValuesRegister
          ref={freightValuesRef}
          cargoValue={cargoValue}
          isNational={isNational}
        />
      </div>
      <div
        className={tabSelected === 'tab2' && isReplacement ? 'd-block' : 'd-none'}
        style={{
          width: '100%',
        }}
      >
        <FreightValuesRegister
          ref={freightValuesReplaceRef}
          cargoValue={cargoValue}
          isNational={isNational}
        />
      </div>
    </>
  );
}
